import { DXObjectViewedBase } from '../types';
import { UserBase } from '../user';
import { SpecAnalytics } from '../specUtils';

export interface MetricBase extends SpecAnalytics {
  // id of the metric
  metric_id_str: string | null;
  // unique name of the formatting
  format_id_str: string | null;
  // metric type as selected in viz settings
  metric_type: 'trend' | 'dimensionality' | 'single-number' | null;
  // dual, single, or null
  aggregation_type_str: string | null;
  // unique name for the type of aggregation: numeric, unique or event. Either the first single metric, or the first dual metric
  aggregation_type_evt_1_str: string | null;
  // if a dual metric, the kind of operator
  aggregation_operator_str: string | null;
  // unique name for the type of aggregation: numeric, unique or event. Either the second dual metric or undefind
  aggregation_type_evt_2_str: string | null;
  // the type of event for either the first single metric, or the first dual metric
  property_kind_evt_1_str: string | null;
  // the type of event for either the second dual metric, or undefined
  property_kind_evt_2_str: string | null;
  // a list of the dependent filters on both events
  metric_dependent_filters: {
    name_strs: string[];
    field_strs: string[];
  };
  // a list of the selected segment(s) by id
  segment_ids_strs: string[];
  // the time range applied to the metric
  time_range_str: string | null;
  // the comparison time range, if any
  comparison_time_range_str: string | null;
  // the frequency applied to the metric
  frequency_str: string | null;
  // the current selected dimension
  dimensionality_ids_strs: string[];
  // the color scheme applied to the metric
  color: string | null;
  rolling_window: {
    // rolling window type applied to the metric
    type_str: 'aggregation' | 'average' | null;
    // rolling window size applied to the metric
    size: number | null;
  };
  visibility: string;
  sort_order: string | null;
  sort_type: string | null;
}

export interface MetricAnalytics extends UserBase, MetricBase {}

export type MetricViewedAnalytics = MetricAnalytics & DXObjectViewedBase;

export enum MetricSaveSource {
  metrics = 'metrics',
  dashboardsV2Editing = 'dashboards v2 editing',
}

export interface MetricSavedAnalytics extends MetricAnalytics {
  save_type_str: 'save_as' | 'save' | 'duplicate';
  // true if a new metric
  is_new_bool: boolean;
  save_type_source_str: MetricSaveSource;
}

export interface MetricArchivedAnalytics extends MetricAnalytics {
  archived_bool: boolean;
}

export interface MetricSessionWatchedAnalytics extends UserBase {}

export type MetricOptionChangedType =
  | 'segment'
  | 'dimension'
  | 'comparison_period'
  | 'time_period'
  | 'time_interval'
  | 'single_number_color'
  | 'trend'
  | 'dimensionality'
  | 'single_number'
  | 'rolling_window';

export interface MetricExploredAnalytics extends UserBase {
  metric_id_str: string;
  option_changed_str: MetricOptionChangedType;
  is_saved_bool: boolean;
  // a string representation of the comparison value selected. Only use this field if the option_changed_str is 'comparison_period'
  comparison_period_str?: string;
}

export interface MetricAddToDashboardAnalytics extends MetricAnalytics, SpecAnalytics {
  card_type_str: string;
}
